// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2rEQd","selected":"Chip_selected__34KmX"};